export default {
  title: '泛函平台',
  project: '项目',
  help: '帮助',
  register: '注册',
  login: '登录',
  logout: '退出登录',
  workbench: '工作台',
  team: '泛团',
  ucenter: '个人中心',
  notHaveAccount: '还没账号？',
  haveAccount: '已有账号？',
  bulletinBoard: '公告栏',
  China: '国内',
  otherCountries: '国外',
  js: {
    success: '成功'
  },
  discover: '玩转泛函'
}



// WEBPACK FOOTER //
// ./src/lang/zh/navbar.js